import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Strategies: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const strategies = [
    { id: '1', name: 'RSI Scalping Strategy', status: 'deployed', pnl: 845.32 },
    { id: '2', name: 'Moving Average Crossover', status: 'backtested', pnl: 1254.89 },
    { id: '3', name: 'Breakout Strategy', status: 'draft', pnl: 0 },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>{t('nav.strategies')}</h1>
        <button className="primary" onClick={() => navigate('/strategies/create')}>
          {t('strategy.create_with_ai')}
        </button>
      </div>

      <div className="grid grid-3">
        {strategies.map((strategy) => (
          <div key={strategy.id} className="card">
            <h3>{strategy.name}</h3>
            <p className={`status ${strategy.status}`}>{t(`strategy.status.${strategy.status}`)}</p>
            {strategy.pnl !== 0 && (
              <p className={`pnl ${strategy.pnl > 0 ? 'positive' : 'negative'}`}>
                {strategy.pnl > 0 ? '+' : ''}${strategy.pnl.toFixed(2)}
              </p>
            )}
            <div style={{ marginTop: '16px', display: 'flex', gap: '8px' }}>
              <button className="secondary">{t('common.edit')}</button>
              <button className="primary">{t('strategy.backtest')}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Strategies;
